class ProductVariantDropdown extends HTMLElement {
    constructor() {
        super(),
        this.addEventListener("change", this.onVariantChange)
    }
    onVariantChange() {
        this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(!0, "", !1),
        this.updatePickupAvailability(),
        this.updateVariantStatuses(),
        this.currentVariant ? (this.updateMedia(),
        this.updateVariantInput(),
        this.renderProductInfo(),
        document.querySelectorAll(".template-product").length && !this.closest("#content_quickview") && this.updateURL()) : (this.toggleAddButton(!0, "", !0),
        this.setUnavailable())
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), select => select.value)
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find(variant => !variant.options.map( (option, index) => this.options[index] === option).includes(!1))
    }
    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media)
            return;
        const newMedia = document.querySelector(`[data-media-id="${this.dataset.productId}-${this.currentVariant.featured_media.id}"]`);
        if (!newMedia)
            return;
        const parent = newMedia.parentElement
          , itemact = document.querySelectorAll(".proFeaturedImage .item");
        for (var i = 0; i < itemact.length; i++)
            itemact[i].classList.remove("act");
        newMedia.classList.add("act"),
        window.setTimeout( () => {
            parent.scroll(0, 0)
        }
        )
    }
    updateURL() {
        !this.currentVariant || this.dataset.updateUrl === "false" || window.history.replaceState({}, "", `${this.dataset.productUrl}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.productId}`).forEach(productForm => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id,
            input.dispatchEvent(new Event("change",{
                bubbles: !0
            }))
        }
        )
    }
    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(":checked").value === variant.option1)
          , inputWrappers = [...this.querySelectorAll("fieldset")];
        inputWrappers.forEach( (option, index) => {
            if (index === 0)
                return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
              , previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value
              , availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        }
        )
    }
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            listOfAvailableOptions.includes(input.getAttribute("value")) ? input.innerText = input.getAttribute("value") : input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"))
        }
        )
    }
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        pickUpAvailability && (this.currentVariant && this.currentVariant.available ? pickUpAvailability.fetchAvailability(this.currentVariant.id) : (pickUpAvailability.removeAttribute("available"),
        pickUpAvailability.innerHTML = ""))
    }
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection || this.dataset.productId;
    
      fetch(`${this.dataset.productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
        .then(response => response.text())
        .then(responseText => {
          const id = `ProductPrice-${this.dataset.productId}`;
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
    
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
          }
    
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
    
          const variantIdElement = document.getElementById("variant_id");
          const variantId = variantIdElement?.getAttribute("value");
    
          const productSelect = document.getElementById("productSelect");
          const selectedOption = productSelect?.querySelector(`[value="${variantId}"]`);
    
          const sku = selectedOption?.getAttribute("data-sku");
          const quantity = selectedOption?.getAttribute("data-qty");
    
          const variantSku = document.getElementById("variantSku");
          const maxQuantity = document.getElementById("Quantity");
    
          if (variantSku && sku) {
            variantSku.innerHTML = sku;
          }
    
          if (maxQuantity && quantity) {
            maxQuantity.setAttribute("max", quantity);
          }
    
          Currency.convertAll(shopCurrency, $("#currencies span.selected").attr("data-currency"));
        });
    }

    toggleAddButton(disable=!0, text, modifyClass=!0) {
        const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
        if (!productForm)
            return;
        const addButton = productForm.querySelector('[name="add"]')
          , addButtonText = productForm.querySelector('[name="add"] > #AddToCartText')
          , addButtonParent = productForm.querySelector(".product-form__item--submit")
          , addButton2 = productForm.querySelector(".product-form__item--checkout");
        if (addButton)
            if (disable) {
                if (text && addButtonParent.setAttribute("data-toggle", "modal"),
                text && addButtonParent.setAttribute("data-target", "#Form_newletter"),
                text && addButtonParent.classList.add("soldout"),
                text && (addButtonText.textContent = text),
                !addButton2)
                    return;
                addButton2.setAttribute("disabled", !0)
            } else {
                const variant_id = document.getElementById("variant_id").getAttribute("value")
                  , inventoryPolicy = document.getElementById("productSelect").querySelector('[value="' + variant_id + '"]').getAttribute("data-inventory_policy")
                  , inventoryManagement = document.getElementById("productSelect").querySelector('[value="' + variant_id + '"]').getAttribute("data-inventory_management");
                if (inventoryPolicy == "continue" && inventoryManagement == "shopify" ? addButtonText.textContent = window.variantStrings.preorder : addButtonText.textContent = window.variantStrings.addToCart,
                addButtonParent.classList.remove("soldout"),
                addButtonParent.removeAttribute("data-toggle"),
                addButtonParent.removeAttribute("data-target"),
                !addButton2)
                    return;
                addButton2.removeAttribute("disabled")
            }
    }
    setUnavailable() {
        const addButton = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="add"]')
          , addButtonText = addButton.querySelector("#AddToCartText");
        addButton && (addButtonText.textContent = window.variantStrings.unavailable)
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData
    }
}
customElements.define("product-variant-dropdown", ProductVariantDropdown);
class ProductVariantSwatch extends ProductVariantDropdown {
    constructor() {
        super()
    }
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            listOfAvailableOptions.includes(input.getAttribute("value")) ? input.classList.remove("disabled") : input.classList.add("disabled")
        }
        )
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map(fieldset => Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value)
    }
}
customElements.define("product-variant-swatch", ProductVariantSwatch);
class ProductVariantSelectsStick extends ProductVariantDropdown {
    constructor() {
        super()
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-sticky-${this.dataset.productId}`).forEach(productForm => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id,
            input.dispatchEvent(new Event("change",{
                bubbles: !0
            }))
        }
        )
    }
    renderProductInfo() {
        fetch(`${this.dataset.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.productId}`).then(response => response.text()).then(responseText => {
            const id = `ProductPriceStick-${this.dataset.productId}`
              , html = new DOMParser().parseFromString(responseText, "text/html")
              , destination = document.getElementById(id)
              , source = html.getElementById(id);
            source && destination && (destination.innerHTML = source.innerHTML),
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me)
        }
        )
    }
    toggleAddButton(disable=!0, text, modifyClass=!0) {
        const productForm = document.getElementById(`product-form-sticky-${this.dataset.productId}`);
        if (!productForm)
            return;
        const addButton = productForm.querySelector('[name="add"]')
          , addButtonText = productForm.querySelector('[name="add"] > #AddToCartText')
          , addButtonParent = productForm.querySelector(".product-form__item--submit")
          , addButton2 = productForm.querySelector(".product-form__item--checkout");
        if (addButton)
            if (disable) {
                if (text && addButtonParent.setAttribute("data-toggle", "modal"),
                text && addButtonParent.setAttribute("data-target", "#Form_newletter"),
                text && addButtonParent.classList.add("soldout"),
                text && (addButtonText.textContent = text),
                !addButton2)
                    return;
                addButton2.setAttribute("disabled", !0)
            } else {
                const variant_id = document.getElementById("variant_id").getAttribute("value")
                  , inventoryPolicy = document.getElementById("productSelect").querySelector('[value="' + variant_id + '"]').getAttribute("data-inventory_policy")
                  , inventoryManagement = document.getElementById("productSelect").querySelector('[value="' + variant_id + '"]').getAttribute("data-inventory_management");
                if (inventoryPolicy == "continue" && inventoryManagement == "shopify" ? addButtonText.textContent = window.variantStrings.preorder : addButtonText.textContent = window.variantStrings.addTobag,
                addButtonParent.classList.remove("soldout"),
                addButtonParent.removeAttribute("data-toggle"),
                addButtonParent.removeAttribute("data-target"),
                !addButton2)
                    return;
                addButton2.removeAttribute("disabled")
            }
    }
    setUnavailable() {
        const addButton = document.getElementById(`product-form-sticky-${this.dataset.productId}`)?.querySelector('[name="add"]')
          , addButtonText = addButton.querySelector("#AddToCartText");
        addButton && (addButtonText.textContent = window.variantStrings.unavailable)
    }
}
customElements.define("product-variant-selects-stick", ProductVariantSelectsStick);
//# sourceMappingURL=/cdn/shop/t/27/assets/nov-product-variants.js.map?v=32884745037009328711744838628
